import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CompanyEnergyWaterDto, UpsertEnergyWaterRequest } from '../../models/api/companyEnergyWaterDto';
import { YearlyResource } from '../../models/api/yearlyResource';

@Injectable({
  providedIn: 'root'
})
export class CompanyEnergyWaterService {
  private apiUrl = `${environment.apiUrl}/companies`;

  constructor(private http: HttpClient) {}

  get(companyId: string, year?: number): Observable<YearlyResource<CompanyEnergyWaterDto>> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.get<YearlyResource<CompanyEnergyWaterDto>>(
      `${this.apiUrl}/${companyId}/energy-and-water`,
      { params }
    );
  }

  upsert(companyId: string, request: UpsertEnergyWaterRequest): Observable<CompanyEnergyWaterDto> {
    return this.http.put<CompanyEnergyWaterDto>(`${this.apiUrl}/${companyId}/energy-and-water`, request);
  }

  delete(companyId: string, year?: number): Observable<void> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.delete<void>(`${this.apiUrl}/${companyId}/energy-and-water`, { params });
  }
}
